export default __webpack_public_path__ + "static/media/Start_Language-DE-2.852c9e64.png";